module.exports = __webpack_public_path__ + "static/media/LogoDE.fba475fd.svg";